import { render, staticRenderFns } from "./ParamsIcon.vue?vue&type=template&id=7b53d280"
import script from "./ParamsIcon.vue?vue&type=script&lang=js"
export * from "./ParamsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports